export default {
  iosUrl: "itms-services://?action=download-manifest&url=https://asset.ncaicai.tech/app/misi/ms.plist",
  androidUrl: "http://asset.ncaicai.tech/app/misi/misi.apk",
  apiDomain: "https://www.xiayue.online",
  sharePrefix: "#misi#",
};
